import domain from './domain';

// Reset client brand profiles
export const resetClientBrandProfiles = domain.createEvent('resetClientBrandProfiles');
